module.exports = __webpack_public_path__ + "img/Pic_Bg_Fz_WRYQ.8c2d8e48.png";